module.exports = __webpack_public_path__ + "static/img/loginBG.93b3afb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/loginBG.png
// module id = xvW4
// module chunks = 0